export default __webpack_public_path__ + "static/media/Icons.912fdbf5.svg";